export const PARAM_KEY_DOCUMENT = "tab-document"
export const PARAM_KEY_DOCUMENT_ROAD = "tab-documentRoad"
export const NETWORK_DOCUMENTS_PAGE = "pPage"
export const ROAD_DOCUMENTS_PAGE = "rPage"
export const DETAILS_DOCUMENTS_PAGE = "dPage"
export const LINEAR_LOCATION_START = "start"
export const LINEAR_LOCATION_END = "end"
export const TYPE_ID = "typeId"